module.exports = __webpack_public_path__ + "img/flat.0b6f79c8.svg";